import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import SearchSelect from "Components/molecule/inputs/search-select"
import TextInput from "Components/molecule/inputs/text-input"
import { SelectOption } from "Components/molecule/inputs/select-input"
import { IGeneratedDocQueryParams } from "models/generated-doc"
import useEnterSearch from "hooks/useEnterSearch"

interface SearchGeneratedDocsFormProps {
    handleChangeQuery: (key: keyof IGeneratedDocQueryParams, value: any) => any,
    handleClearSearch: () => any,
    handleSearch: () => any,
    documents: SelectOption[],
    managers: SelectOption[],
    statuses: SelectOption[],
    query: IGeneratedDocQueryParams
    isSearching: boolean
}

const SearchGeneratedDocsForm = ({
    handleChangeQuery,
    handleClearSearch,
    handleSearch,
    documents,
    managers,
    statuses,
    query,
    isSearching
}: SearchGeneratedDocsFormProps) => {

    const { inputProps, selectProps } = useEnterSearch(handleSearch)

    return (
        <SearchFormContainer
            inputs={
                <>
                    <SearchSelect
                        label="Document"
                        options={documents}
                        value={query.documentId ?? ""}
                        onChange={(e) => handleChangeQuery("documentId", e?.value ?? "")}
                        clearable
                        {...selectProps}
                    />

                    <SearchSelect
                        label="Manager"
                        options={managers}
                        value={query.managerId ?? ""}
                        onChange={(e) => handleChangeQuery("managerId", e?.value ?? "")}
                        clearable
                        {...selectProps}
                    />

                    <TextInput
                        label="Employee Name"
                        value={query.recruitName ?? ""}
                        onChange={(e) => handleChangeQuery("recruitName", e?.target.value ?? "")}
                        placeholder="e.g. Jane Doe"
                        {...inputProps}
                    />

                    <SearchSelect
                        label="Status"
                        options={statuses}
                        value={query.statusId ?? ""}
                        onChange={(e) => handleChangeQuery("statusId", e?.value ?? "")}
                        clearable
                        {...selectProps}
                    />
                </>
            }
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{
                            minWidth: '150px'
                        }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{
                            minWidth: '100px'
                        }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchGeneratedDocsForm
